import { Action } from 'redux'

import ClientPassengerInterface from '../../interfaces/client/Passenger'

import { ADD_UPLOADED_PASSENGERS } from '../../actions/passengers/addUploadedPassengers'

export interface UploadedPassengersState {
  byId: {
    [id: string]: ClientPassengerInterface
  }
  allIds: string[]
}

export interface UploadedPassengersAction extends Action {
  passengers: ClientPassengerInterface[]
}

export interface NormalizePassengers {
  [id: string]: ClientPassengerInterface
}

export const initialState: UploadedPassengersState = {
  byId: {},
  allIds: [],
}

export default (
  state = initialState,
  action: UploadedPassengersAction = { type: '', passengers: [] }
) => {
  switch (action.type) {
    case ADD_UPLOADED_PASSENGERS:
      const allPassengers = action.passengers.reduce(
        (
          passengers: NormalizePassengers,
          passenger: ClientPassengerInterface
        ) => ({
          ...passengers,
          [passenger.id]: passenger,
        }),
        {}
      )

      return {
        ...state,
        byId: allPassengers,
        allIds: Object.keys(allPassengers),
      }

    case '@@router/LOCATION_CHANGE':
      return initialState

    default:
      return state
  }
}
